/* Set-Konfigurator (Prototyp & Shopify-Theme)
   Liest die Konfiguration aus <script type="application/json" data-set-config>.
   Preise in Cent. Alle Teile werden als echte Einzelprodukte in den Warenkorb gelegt. */
(function () {
  'use strict';
  var root = document.querySelector('[data-set]');
  var cfgEl = document.querySelector('[data-set-config]');
  if (!root || !cfgEl) return;
  var C;
  try { C = JSON.parse(cfgEl.textContent); }
  catch (err) {
    console.error('Set-Konfigurator: Konfiguration fehlerhaft', err, cfgEl.textContent);
    var box = root.querySelector('[data-set-heaters]');
    if (box) box.innerHTML = '<p class="set-hint" data-state="warn">Der Konfigurator konnte nicht geladen werden (Konfiguration fehlerhaft).</p>';
    return;
  }
  ['heaters', 'modules', 'connectors', 'cables'].forEach(function (k) { C[k] = C[k] || []; });
  var empty = function (txt) { return '<p class="set-hint" data-state="warn">' + txt + '</p>'; };
  var eur = function (cents) { return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); };
  var num = function (v, d) { return v.toLocaleString('de-DE', { minimumFractionDigits: d || 0, maximumFractionDigits: d || 0 }); };

  // Module, die zum gewählten Heizstab passen (onlyFor = Produkt-ID des Heizstabs, leer = alle)
  function modulesFor(hi) {
    var pid = C.heaters[hi] && C.heaters[hi].pid;
    return C.modules.map(function (m, i) { return i; }).filter(function (i) { return !C.modules[i].onlyFor || C.modules[i].onlyFor === pid; });
  }
  var state = {
    heater: 0,
    variant: 0,
    module: 0,
    count: C.defaultCount || 3,
    connectors: {},   // Index -> Anzahl
    cables: {},       // Index -> Anzahl
    connectorsTouched: false,
    cablesTouched: false
  };

  /* Gerät + gewählte Variante + Regeln (vorausgewählt / maximal / Empfehlung je Variante) */
  function cur() {
    var h = C.heaters[state.heater] || {}, vs = h.variants || [];
    var v = vs[state.variant] || vs[0] || { id: h.id, title: '', price: h.price, image: h.image };
    var r = (h.rules || []).filter(function (x) { return x.variant && v.title && x.variant.trim() === v.title.trim(); })[0] || {};
    var max = r.max || h.maxModules || 6;
    if (h.wiring === 'tracker') max = Math.min(max, (h.trackers || 3) * 2);
    return { h: h, v: v, multi: vs.length > 1, max: max, def: Math.min(r.def || h.defaultCount || C.defaultCount || 3, max), rec: r.rec || h.recommended };
  }
  function resetForDevice() {
    var c = cur();
    state.count = c.def; state.connectorsTouched = false; state.cablesTouched = false;
    C.cables.forEach(function (cb, i) { state.cables[i] = cb.default ? suggestCables(state.count) : 0; });
  }
  function suggestCables(n) { var h = cur().h; return h.wiring === 'tracker' ? Math.max(1, Math.ceil(n / 2)) : 1; }
  function pickModule() {
    var allowed = modulesFor(state.heater);
    if (allowed.indexOf(state.module) === -1) {
      var def = allowed.filter(function (i) { return C.modules[i].default; });
      state.module = def.length ? def[0] : (allowed[0] || 0);
    }
  }
  pickModule();

  /* Parallelstecker-Vorschlag.
     „parallel“: alle Module an einen Eingang – bis 4 Module ein passender Stecker; 5: 4er + 2er; 6: 4er + 3er.
     „tracker“: je 2 Module pro MPP-Tracker – pro Modulpaar ein 2er-Stecker. */
  function suggestConnectors(n) {
    var want = {};
    if (cur().h.wiring === 'tracker') { if (n >= 2) want[2] = Math.floor(n / 2); }
    else if (n >= 2 && n <= 4) want[n] = 1;
    else if (n === 5) { want[4] = 1; want[2] = 1; }
    else if (n === 6) { want[4] = 1; want[3] = 1; }
    var out = {};
    C.connectors.forEach(function (c, i) { out[i] = want[c.n] || 0; });
    return out;
  }
  resetForDevice();
  state.connectors = suggestConnectors(state.count);

  // ---------- Darstellung ----------
  var $ = function (s) { return root.querySelector(s); };
  function stepper(name, i, val, min, max) {
    return '<div class="set-stepper" data-name="' + name + '" data-i="' + i + '">' +
      '<button type="button" data-d="-1" aria-label="weniger"' + (val <= min ? ' disabled' : '') + '>−</button>' +
      '<output>' + val + '</output>' +
      '<button type="button" data-d="1" aria-label="mehr"' + (val >= max ? ' disabled' : '') + '>+</button></div>';
  }

  function renderStatic() {
    // Heizstäbe
    if (!C.heaters.length) { $('[data-set-heaters]').innerHTML = empty('Noch kein Heizstab hinterlegt.'); }
    else {
      $('[data-set-heaters]').innerHTML = C.heaters.map(function (h, i) {
        var v = i === state.heater ? cur().v : (h.variants && h.variants[0]) || h;
        return '<button type="button" class="set-option" data-heater="' + i + '" aria-pressed="' + (i === state.heater) + '">' +
          ((v.image || h.image) ? '<img src="' + (v.image || h.image) + '" alt="" loading="lazy">' : '') +
          '<span class="set-option__name">' + h.title + '</span><span class="set-option__meta">' + h.subtitle + '</span>' +
          '<span class="set-option__price">' + eur(v.price) + '</span></button>';
      }).join('');
      var c = cur();
      var vw = root.querySelector('[data-set-variants]');
      if (!vw) { vw = document.createElement('div'); vw.className = 'set-variants'; vw.setAttribute('data-set-variants', ''); $('[data-set-heaters]').after(vw); }
      vw.hidden = !c.multi;
      vw.innerHTML = c.multi ? '<span class="set-variants__label">Größe</span>' + c.h.variants.map(function (v, i) {
        return '<button type="button" class="set-variant" data-variant="' + i + '" aria-pressed="' + (i === state.variant) + '">' + v.title + '</button>';
      }).join('') : '';
    }
    // Module
    $('[data-set-modules]').innerHTML = C.modules.map(function (m, i) {
      return '<div class="set-option-wrap"' + (modulesFor(state.heater).indexOf(i) === -1 ? ' hidden' : '') + '>' +
        '<button type="button" class="set-option" data-module="' + i + '" aria-pressed="' + (i === state.module) + '">' +
        (m.image ? '<img src="' + m.image + '" alt="" loading="lazy">' : '<span class="set-option__ph"></span>') +
        '<span class="set-option__name">' + m.title + '</span><span class="set-option__meta">' + num(m.wp) + ' Wp · MPP ' + num(m.vmpp, 1) + ' V' + (m.voc ? ' · Voc ' + num(m.voc, 1) + ' V' : '') + '</span>' +
        '<span class="set-option__price">' + eur(m.price) + ' / Stück</span></button>' +
        (m.sheet ? '<a class="set-sheet" href="' + m.sheet + '" target="_blank" rel="noopener">Datenblatt (PDF) ›</a>' : '') +
        '</div>';
    }).join('');
    if (!modulesFor(state.heater).length) $('[data-set-modules]').innerHTML = empty('Für diesen Heizstab sind noch keine PV-Module hinterlegt.');
  }

  function render() {
    var c = cur(), h = c.h, m = modulesFor(state.heater).length ? C.modules[state.module] : null, n = state.count;
    if (!C.heaters.length) return;
    root.querySelectorAll('[data-heater]').forEach(function (b) { b.setAttribute('aria-pressed', String(+b.dataset.heater === state.heater)); });
    root.querySelectorAll('[data-module]').forEach(function (b) { b.setAttribute('aria-pressed', String(+b.dataset.module === state.module)); });

    // Modulanzahl
    $('[data-set-count]').innerHTML = stepper('count', 0, n, 1, c.max);
    var rec = $('[data-set-rec]'); if (rec) rec.textContent = c.rec ? 'empfohlen: ' + c.rec : '';

    // Parallelstecker
    if (!state.connectorsTouched) state.connectors = suggestConnectors(n);
    var sugg = suggestConnectors(n), suggText = C.connectors.filter(function (c, i) { return sugg[i]; })
      .map(function (c) { return sugg[C.connectors.indexOf(c)] + '× ' + c.label; }).join(' + ');
    var trackerNote = h.wiring === 'tracker' ? 'Je 2 Module teilen sich einen MPP-Tracker. ' : '';
    $('[data-set-conn-hint]').innerHTML = n < 2 ? 'Bei einem Modul brauchst du keinen Parallelstecker.'
      : trackerNote + 'Für ' + n + ' Module empfehlen wir: <strong>' + suggText + '</strong>' +
        (state.connectorsTouched ? ' · <button type="button" class="set-link" data-reset="connectors">Vorschlag übernehmen</button>' : '');
    $('[data-set-connectors]').innerHTML = !C.connectors.length ? empty('Noch keine Parallelstecker hinterlegt.') : C.connectors.map(function (c, i) {
      return '<div class="set-row"><span class="set-row__name">' + c.label + '<small>' + eur(c.price) + '</small></span>' + stepper('conn', i, state.connectors[i] || 0, 0, 10) + '</div>';
    }).join('');

    // Kabel (bei Tracker-Anschluss: eine Leitung pro belegtem Tracker)
    if (!state.cablesTouched) C.cables.forEach(function (cb, i) { state.cables[i] = cb.default ? suggestCables(n) : 0; });
    $('[data-set-cables]').innerHTML = !C.cables.length ? empty('Noch keine Verlängerungskabel hinterlegt.') : C.cables.map(function (c, i) {
      return '<div class="set-row"><span class="set-row__name">' + c.label + '<small>' + eur(c.price) + '</small></span>' + stepper('cable', i, state.cables[i] || 0, 0, 10) + '</div>';
    }).join('');
    var meters = C.cables.reduce(function (s, c, i) { return s + c.m * (state.cables[i] || 0); }, 0);
    var cEl = $('[data-set-cable-hint]');
    cEl.textContent = meters === 0 ? 'Ohne Verlängerungskabel – nur sinnvoll, wenn die Module direkt neben dem Speicher stehen.'
      : meters > 25 ? 'Zusammen ' + meters + ' m. Halte den Kabelweg möglichst unter 25 m – darüber steigen die Leitungsverluste.'
      : 'Zusammen ' + meters + ' m Kabel.';
    cEl.dataset.state = meters > 25 ? 'warn' : 'ok';

    // Zusammenfassung
    var lines = [{ id: c.v.id, q: 1, title: h.title + (c.multi ? ' ' + c.v.title : ''), price: c.v.price }];
    if (m) lines.push({ id: m.id, q: n, title: m.title, price: m.price });
    C.connectors.forEach(function (c, i) { if (state.connectors[i]) lines.push({ id: c.id, q: state.connectors[i], title: 'Parallelstecker ' + c.title, price: c.price }); });
    C.cables.forEach(function (c, i) { if (state.cables[i]) lines.push({ id: c.id, q: state.cables[i], title: 'Verlängerungskabel ' + c.title, price: c.price }); });
    var sub = lines.reduce(function (s, l) { return s + l.q * l.price; }, 0);
    var okMin = !C.discount.min || sub >= C.discount.min;
    var disc = okMin ? Math.round(sub * (C.discount.percent || 0) / 100) : 0;
    var codeEl = $('[data-set-code]');
    if (codeEl) codeEl.textContent = okMin ? codeEl.dataset.ok : codeEl.dataset.min.replace('__AMOUNT__', eur(C.discount.min));
    $('[data-set-lines]').innerHTML = lines.map(function (l) {
      return '<li><span>' + l.q + '× ' + l.title + '</span><span>' + eur(l.q * l.price) + '</span></li>';
    }).join('');
    $('[data-set-sub]').textContent = eur(sub);
    $('[data-set-disc]').textContent = '−' + eur(disc);
    $('[data-set-disc-row]').hidden = !disc;
    $('[data-set-total]').textContent = eur(sub - disc);
    var mt = $('[data-set-mobile-total]'); if (mt) mt.textContent = eur(sub - disc);
    state.lines = lines;
  }

  // ---------- Bedienung ----------
  root.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return;
    if (b.dataset.heater) { state.heater = +b.dataset.heater; state.variant = 0; resetForDevice(); pickModule(); renderStatic(); render(); }
    else if (b.dataset.variant) { state.variant = +b.dataset.variant; resetForDevice(); renderStatic(); render(); }
    else if (b.dataset.module) { state.module = +b.dataset.module; render(); }
    else if (b.dataset.reset === 'connectors') { state.connectorsTouched = false; render(); }
    else if (b.dataset.d) {
      var s = b.closest('.set-stepper'), i = +s.dataset.i, d = +b.dataset.d;
      if (s.dataset.name === 'count') state.count = Math.max(1, Math.min(cur().max, state.count + d));
      if (s.dataset.name === 'conn') { state.connectors[i] = Math.max(0, Math.min(10, (state.connectors[i] || 0) + d)); state.connectorsTouched = true; }
      if (s.dataset.name === 'cable') { state.cables[i] = Math.max(0, Math.min(10, (state.cables[i] || 0) + d)); state.cablesTouched = true; }
      render();
    }
    else if (b.hasAttribute('data-set-add')) addToCart(b);
  });

  function addToCart(btn) {
    var c = cur(), setName = c.h.title + (c.multi ? ' ' + c.v.title : '') + ' – Set';
    if (C.mode === 'demo') {
      var t = document.querySelector('.toast');
      if (t) { t.textContent = 'Prototyp – im Shop landen jetzt alle ' + state.lines.length + ' Positionen im Warenkorb.'; t.classList.add('is-visible'); setTimeout(function () { t.classList.remove('is-visible'); }, 3500); }
      return;
    }
    btn.disabled = true; btn.textContent = 'Wird hinzugefügt …';
    var items = state.lines.map(function (l) { return { id: l.id, quantity: l.q, properties: { _Set: setName } }; });
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        var cart = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
        location.href = C.discount.code && (!C.discount.min || state.lines.reduce(function (s, l) { return s + l.q * l.price; }, 0) >= C.discount.min) ? '/discount/' + encodeURIComponent(C.discount.code) + '?redirect=' + encodeURIComponent(cart) : cart;
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Erneut versuchen'; });
  }

  var jump = document.querySelector('[data-set-jump]');
  if (jump) jump.addEventListener('click', function (e) { e.preventDefault(); $('[data-set-add]').scrollIntoView({ behavior: 'smooth', block: 'center' }); });
  renderStatic();
  render();
})();
